export default __webpack_public_path__ + "static/image2-d6910a2a771d4b6d354ab795e37fe7d2.png";